import { usePage, useWebsiteSettings } from 'client/store'
import { pageSelectors } from 'client/store/page/pageSelectors'
import { typographySelectorMap } from 'src/editor/store/website-settings/website-settings-selector'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'
export const useFontStyle = ({
  fontStyle,
  mobileFontStyle,
  typographyType = WebsiteSettingsTypographyTypeEnum.Paragraph,
}: {
  fontStyle?: string
  mobileFontStyle?: string
  typographyType?: WebsiteSettingsTypographyTypeEnum
}) => {
  const pageGlobalFontStyle = usePage(
    pageSelectors.getGlobalFontProperties,
  ).fontStyle

  const typographySelector = typographySelectorMap[typographyType]

  const {
    fontStyle: websiteGlobalFontStyle,
    mobileFontStyle: globalMobileFontStyle,
  } = useWebsiteSettings(typographySelector) || {}

  const globalFontStyle = pageGlobalFontStyle || websiteGlobalFontStyle

  return {
    calculatedFontStyle: getCalculatedProperty({
      desktopProperty: fontStyle,
      mobileProperty: mobileFontStyle,
      globalDesktopProperty: globalFontStyle,
      globalMobileProperty: globalMobileFontStyle,
    }),
    globalFontStyle,
    globalMobileFontStyle: globalMobileFontStyle || globalFontStyle,
  }
}
